import { CheckRule } from '../../constants/regular.constant';

/**
 * 判断税务注册号是否可以复制到增值税号。
 * @param fiscalCode 当前税务注册号
 * @param regularType 复制目标字段校验规则：
 *   - 省略时默认 `fiscalCode`（集团账号等场景）
 *   - 传入规则 key 时按该规则校验（如 `vatNumber` / `spainVatNumber`）
 *   - 传入 `null` 表示不校验格式（无国家 VAT 正则时与表单一致）
 * @returns 允许复制时返回 true
 */
export function isFiscalCodeValidForCopy(
    fiscalCode: string,
    regularType: string | null = 'fiscalCode',
): boolean {
    // 空值不可复制
    if (!fiscalCode.trim()) {
        return false;
    }
    // 无目标字段正则时与表单一致，跳过格式校验
    if (regularType === null) {
        return true;
    }
    return CheckRule(regularType, fiscalCode);
}
